import React from "react";

// static imports for icons
import undoIcon  from "../assets/undo.svg";
import resetIcon from "../assets/reset.svg";

interface ControlsProps {
  undoEnabled: boolean;
  resetEnabled: boolean;
  onUndo: () => void;
  onReset: () => void;
  moves: number;
  scale: number;
}

export default function Controls({
  undoEnabled,
  resetEnabled,
  onUndo,
  onReset,
  moves,
  scale,
}: ControlsProps) {
  const iconSize = 30 * scale;
  const fontSize = 16 * scale;

  return (
    <div 
    className="controls" 
    style={{ 
      fontSize: `${fontSize}px`,
      display: "flex",
      alignItems: "center",
      marginTop: "1rem",
    }}>
      <button
        className="controls__undo"
        onClick={onUndo}
        disabled={!undoEnabled}
        aria-label="Undo"
      >
        <img src={undoIcon} alt="Undo" width={iconSize} height={iconSize} />
      </button>

      <span className="controls__moves">Moves: {moves}</span>

      <button
        className="controls__reset"
        onClick={onReset}
        disabled={!resetEnabled}
        aria-label="Reset"
      >
        <img src={resetIcon} alt="Reset" width={iconSize} height={iconSize} />
      </button>
    </div>
  );
}
